module.exports = __webpack_public_path__ + "img/banner3.548e46b.jpg";